import { CSSProperties, FC, SVGProps } from 'react'
import wazzupLogo from '@/images/wazzup-logo.png'

/** fill у svg-иконок = disabled soft → для png имитируем серый вид. */
const isDisabledFill = (fill: CSSProperties['fill']): boolean => {
  if (typeof fill !== 'string' || !fill.trim()) {
    return false
  }
  const normalized = fill.trim().toLowerCase()
  return (
    normalized.includes('disabled') ||
    normalized === 'var(--color-button-icon-disabled-soft)'
  )
}

/** Логотип Wazzup (png) — размеры задаёт родительский CSS (как у svg). */
const WazzupIcon: FC<SVGProps<SVGSVGElement>> = ({ className, style }) => {
  const disabled = isDisabledFill(style?.fill)
  const imgStyle: CSSProperties = {
    display: 'block',
    objectFit: 'cover',
    borderRadius: '50%',
    flexShrink: 0,
    ...style,
    // png не красится через fill — при disabled серим фильтром
    fill: undefined,
    ...(disabled
      ? {
          opacity: 0.45,
          filter: 'grayscale(1)',
        }
      : {}),
  }

  return (
    <img
      src={wazzupLogo}
      alt=""
      className={className}
      style={imgStyle}
      width={16}
      height={16}
      draggable={false}
    />
  )
}

export default WazzupIcon
